import React from 'react';
import { Empty } from 'antd';
import s from './index.module.css';

const EmptyData = ({ description }) => {
  return (
    <div className={s.emptyContainer}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={description || '暂无数据'}
      />
    </div>
  );
};

export default EmptyData;